import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchList(ctx, params) {
      return axios.get('/strips', { params })
    },
    loadStrip(ctx, { id }) {
      return axios.get(`/strips/${id}`)
    },
    createStrip(ctx, payload) {
      return axios.post('/strips', payload)
    },
    updateStrip(ctx, { id, payload }) {
      return axios.patch(`/strips/${id}`, payload)
    },
    deleteStrip(ctx, { id }) {
      return axios.delete(`/strips/${id}`)
    },
    finalizeStrip(ctx, { id }) {
      return axios.post(`/strips/${id}/finalize`)
    },
    fetchAuthors() {
      return axios.get('/strips/authors')
    },
    fetchAutotopics() {
      return axios.get('/strips/autotopics')
    },
    fetchLookups() {
      return axios.get('/strips/lookups')
    },
    suggestArtist(ctx, { stripId, autotopicId = null }) {
      const params = {}
      if (autotopicId) params.autotopic_id = autotopicId
      return axios.get(`/strips/${stripId}/suggest-artist`, { params })
    },
    suggestTrack(ctx, { stripId, artistId, kind = 'melody' }) {
      return axios.get(`/strips/${stripId}/suggest-track/${artistId}`, { params: { kind } })
    },
    suggestCovers(ctx, { stripId, artistId }) {
      return axios.get(`/strips/${stripId}/suggest-covers/${artistId}`)
    },
    acceptQuestion(ctx, { stripId, payload }) {
      return axios.post(`/strips/${stripId}/questions`, payload)
    },
    acceptManualQuestion(ctx, { stripId, formData, onUploadProgress }) {
      return axios.post(`/strips/${stripId}/questions/manual`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress,
      })
    },
    deleteQuestion(ctx, { stripId, questionId }) {
      return axios.delete(`/strips/${stripId}/questions/${questionId}`)
    },
    updateQuestion(ctx, { stripId, questionId, payload }) {
      return axios.patch(`/strips/${stripId}/questions/${questionId}`, payload)
    },
    updatePart(ctx, { stripId, questionId, partId, payload }) {
      return axios.patch(`/strips/${stripId}/questions/${questionId}/parts/${partId}`, payload)
    },
    reorderParts(ctx, { stripId, questionId, order }) {
      return axios.post(`/strips/${stripId}/questions/${questionId}/parts/reorder`, { order })
    },
    addPart(ctx, { stripId, questionId, payload }) {
      return axios.post(`/strips/${stripId}/questions/${questionId}/parts`, payload)
    },
    deletePart(ctx, { stripId, questionId, partId }) {
      return axios.delete(`/strips/${stripId}/questions/${questionId}/parts/${partId}`)
    },
    attachStat(ctx, { stripId, questionId, kind, id }) {
      return axios.post(`/strips/${stripId}/questions/${questionId}/stats`, { kind, id })
    },
    detachStat(ctx, { stripId, questionId, kind, id }) {
      return axios.delete(`/strips/${stripId}/questions/${questionId}/stats`, { data: { kind, id } })
    },
    replaceAudioPart(ctx, { stripId, questionId, partId, payload }) {
      return axios.post(`/strips/${stripId}/questions/${questionId}/parts/${partId}/replace-audio`, payload)
    },
    replaceCovers(ctx, { stripId, questionId, coverIds }) {
      return axios.put(`/strips/${stripId}/questions/${questionId}/covers`, { cover_ids: coverIds })
    },
    reorderQuestions(ctx, { stripId, order }) {
      return axios.post(`/strips/${stripId}/questions/reorder`, { order })
    },
    searchArtists(ctx, { q, autotopicId = null }) {
      const params = { q }
      if (autotopicId) params.autotopic_id = autotopicId
      return axios.get('/artist', { params })
    },
    fetchArtistTracks(ctx, { artistId, kind = 'melody' }) {
      const params = {
        artist_id: artistId,
        has_file: 1,
        is_cover: kind === 'cover' ? 1 : 0,
        sort_by: 'play_count',
        sort_desc: 1,
        per_page: 200,
      }
      return axios.get('/track', { params })
    },
    fetchArtistCovers(ctx, { artistId }) {
      return axios.get(`/artist/${artistId}/covers`)
    },
    importArchive(ctx, { formData, onUploadProgress }) {
      return axios.post('/strips/import-archive', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress,
      })
    },
    importSiq(ctx, { formData, onUploadProgress }) {
      return axios.post('/strips/import-siq', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress,
      })
    },
  },
}
